export default __webpack_public_path__ + "static/media/img4.3b97a1fb.jpg";